import { render, staticRenderFns } from "./userRepositories.vue?vue&type=template&id=1457e31c&scoped=true&"
import script from "./userRepositories.vue?vue&type=script&lang=js&"
export * from "./userRepositories.vue?vue&type=script&lang=js&"
import style0 from "./userRepositories.vue?vue&type=style&index=0&id=1457e31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457e31c",
  null
  
)

export default component.exports